import { usePostHog } from '@posthog/react';
import { useEffect } from 'react';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';
import { useAuthWrapper } from '@weareopenr/authkit';

export const useUserTracking = () => {
  const posthog = usePostHog();
  const { organizationId, impersonator } = useAuthWrapper();
  const brandId = getBrandId();

  useEffect(() => {
    if (posthog) {
      // These will be added to ALL events automatically
      posthog.register({
        system: 'hub',
        ...(organizationId && { organizationId }),
        ...(brandId && { brandId }),
        ...(impersonator && { impersonator }),
      });
    }
  }, [posthog, organizationId, brandId, impersonator]);

  const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.capture(eventName, properties);
    }
  };

  const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.identify(userId, properties);
    }
  };

  const captureException = (error: unknown, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.captureException(error, properties);
    }
  };

  return {
    trackEvent,
    identifyUser,
    captureException,
  };
};
